import { type ComponentProps, forwardRef, useMemo } from 'react';
import { ScrollView, type ViewStyle } from 'react-native';

import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const ScrollspyNav = forwardRef<ScrollView, ScrollspyNavProps>((props, ref) => {
  const {
    children,
    gap = theme.spacing['1'],
    stagePadding,
    contentContainerStyle,
    ...restProps
  } = props;

  // ─── Styles ────────────────────────────────────────────────────────────

  const dynamicStyles = useMemo<ViewStyle>(
    () => ({
      columnGap: gap,
      paddingHorizontal: stagePadding,
    }),
    [gap, stagePadding],
  );
  const contentContainerStyles = [dynamicStyles, contentContainerStyle];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <ScrollView
      ref={ref}
      showsHorizontalScrollIndicator={false}
      horizontal
      accessibilityRole="tablist"
      contentContainerStyle={contentContainerStyles}
      scrollEventThrottle={16}
      {...restProps}
    >
      {children}
    </ScrollView>
  );
});

ScrollspyNav.displayName = 'ScrollspyNav';

// ─── Types ───────────────────────────────────────────────────────────────────

type ScrollspyNavProps = {
  gap?: ViewStyle['gap'];
  stagePadding?: number;
} & Omit<ComponentProps<typeof ScrollView>, 'horizontal'>;
